<app-agent-list
  [agents]="agents"
  [copiedAgents]="copiedAgents"
  [loaded]="loaded"
  (emitUpdateAgents)="getAgents()"
>
</app-agent-list>
